import {
  Box,
  Flex,
  Heading,
  Text,
  Input,
  Button,
  Image,
  useToast,
  FormControl,
  FormLabel,
  Link
} from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate } from 'react-router-dom';

export default function SignUp() {
  const [email, setEmail] = useState("");
  const toast = useToast();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
  e.preventDefault();

  // Create a real Mailchimp POST form
  const form = document.createElement("form");
  form.action = "https://beer.us20.list-manage.com/subscribe/post?u=56dc3e7a1674d11042318c1cf&amp;id=d09d6dc1f6&amp;f_id=00f278eaf0";
  form.method = "POST";
  form.target = "_blank";

  const input = document.createElement("input");
  input.type = "hidden";
  input.name = "EMAIL";
  input.value = email;

  form.appendChild(input);
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);

  toast({
    title: "Thanks!",
    description: "You’ll hear from us soon.",
    status: "success",
    duration: 5000,
    isClosable: true,
  });

  setEmail("");
};


  return (
    <Flex
      minH="100vh"
      direction="column"
      bgImage="url('/images/bg-holding.jpg')"
      bgSize="cover"
      bgPosition="center"
      bgRepeat="no-repeat"
      align="center"
      px={4}
      pt="66px"
    >
      <Box maxW="840px" w="full" textAlign="left">
        <Image
          src="/images/Logo.png"
          alt="Matterbrew Logo"
          maxW="334px"
          w="100%"
          mb={10}
        />

        <Heading
          fontSize={{ base: "58px", md: "72px", lg: "97px" }}
          fontFamily="'lorimer-no-2-condensed', sans-serif"
          fontWeight="700"
          color="#fff"
          lineHeight=".9"
          textShadow="0px 4px 22px rgba(0, 0, 0, 0.8)"
          mb={6}
        >
          Brew smarter. Share better. Your craft deserves it.
        </Heading>

        <form onSubmit={handleSubmit}>
          <FormControl id="email" mb={6}>
            <FormLabel
              htmlFor="email"
              color="white"
              fontSize="18px"
              fontFamily="'lorimer-no-2-condensed', sans-serif"
              fontWeight="600"
            >
              Email
            </FormLabel>
            <Flex
              direction={{ base: "column", md: "row" }}
              align="start"
            >
              <Input
                id="email"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                bg="white"
                color="#293C49"
                fontSize="18px"
                fontFamily="'lorimer-no-2-condensed', sans-serif"
                fontWeight="600"
                lineHeight="1.4"
                mr={{ base: 0, md: 2 }}
                mb={{ base: 3, md: 0 }}
                py="16px"
                px="16px"
                required
              />
              <Button
                type="submit"
                bg="#083D59"
                color="#FFBF4E"
                fontSize="18px"
                fontFamily="'lorimer-no-2-condensed', sans-serif"
                fontWeight="600"
                px="26px"
                py="6px"
                _hover={{ bg: "#062e45" }}
              >
                Request early access
              </Button>
            </Flex>
          </FormControl>
        </form>
        <Text
          mt={4}
          color="#fff"
          fontSize="18px"
          fontFamily="'lorimer-no-2-condensed', sans-serif"
          fontWeight="600"
          textShadow="0px 4px 22px rgba(0, 0, 0, 0.8)"
        >We’re launching soon. No spam all beer and updates. 
          </Text><Text
          mt={4}
          color="#fff"
          fontSize="18px"
          fontFamily="'lorimer-no-2-condensed', sans-serif"
          fontWeight="600"
          textShadow="0px 4px 22px rgba(0, 0, 0, 0.8)"
        >Have early access? {" "}
          <Link
            onClick={() => navigate("/login")}
            color="#FFBF4E"
            fontWeight="bold"
            cursor="pointer"
            fontSize="18px"
            fontFamily="'lorimer-no-2-condensed', sans-serif"
            fontWeight="600"
          >
            Sign in
          </Link>
        </Text>
      </Box>
    </Flex>
  );
}
